import React, { useEffect, useMemo, useState } from 'react';
import { User, Mail, Phone, X, Upload } from 'lucide-react';
import { useWizard } from '../../Contexts/WizardContext';
import { Button } from '../General/Button';
import Input from '../General/Input';
import Loader from '../General/Loader';
import { createDealTCM, getDeepLawnMeasurments } from '../../api/endpoints';

const requiredFileds = ['firstName', 'lastName', 'email', 'phone']

export default function ContactInfoTCM() {
    const { updateFormData, nextStep, previousStep, formData, setCustomStep } = useWizard();
    const [contactData, setContactData] = useState(formData?.contactData || null)
    const [isSaveButtonBlocked, setIsSaveButtonBlocked] = useState(formData?.contactData ? false : true)
    const [isLoading, setIsLoading] = useState(true)
    
    useEffect(() => {
      async function fetch() {
        if (formData.propertyType == 'single-family') {
          const response = await getDeepLawnMeasurments(formData.address.formattedAddress)
          console.log('response', response)
          if (response.status == 'success') {
            updateFormData(oldVal => {
              return {
                ...oldVal,
                propertyMeasurments: response.square_feet
              }
            })
          } else {
            // to handle deepLawn pending case
            console.log('DeepLawn pending case', formData.address.formattedAddress)
          }

        }
        setIsLoading(false)
      }
      fetch()
    }, [formData.propertyType])

    useEffect(() => {
        if (!contactData) return; // Guard clause

        let toBlockSaveButton = false
        requiredFileds.forEach(fieldName => {
        if (!contactData[fieldName] || contactData[fieldName] == '') {
            toBlockSaveButton = true
        }
        })
        setIsSaveButtonBlocked(toBlockSaveButton)
    }, [contactData])

    const onFormDataChange = (value, fieldName) => {
        setContactData(val => {
        return {
            ...val,
            [fieldName]: value
        }
        })
    }

    const onSubmit = async () => {
        setIsLoading(true)
        
        const dealId = await createDealTCM({...formData, contactData})

        updateFormData(val => {
          return {
            ...val,
            contactData: contactData,
            dealId: dealId
          }
        })
        setIsLoading(false)
        if (formData.propertyType == 'commercial') {
          setCustomStep(5)
        } else {
          nextStep()
        }        
      };

      // -------- FOR FUTURE IMAGE UPLOAD ---------
      // const handleImageUpload = (event) => {
      //   const files = Array.from(event.target.files);
      //   const validFiles = [];
      //   let processedCount = 0;
      
      //   // Filter valid files first
      //   files.forEach((file) => {
      //     const isImage = file.type.startsWith('image/');
          
      //     if (!isImage) {
      //       console.log(`File ${file.name} is not an image`);
      //       return;
      //     }
      
      //     const maxSize = 10 * 1024 * 1024
      //     if (file.size > maxSize) {
      //       console.warn(`File ${file.name} is too large (${(file.size / 1024 / 1024).toFixed(1)}MB)`);
      //       return;
      //     }
      
      //     validFiles.push({ file, isImage });
      //   });
      
      //   if (validFiles.length === 0) return;
      
      //   const fileDataArray = [];
      
      //   // Process each valid file
      //   validFiles.forEach(({ file, isImage, isVideo }) => {
      //     const fileData = {
      //       name: file.name,
      //       type: file.type,
      //       size: file.size,
      //       data: file, // Use the raw File object, not base64
      //     };
          
      //     fileDataArray.push(fileData);
      //     processedCount++;
      
      //     // Update form data only when all files are processed
      //     if (processedCount === validFiles.length) {
      //       onFormDataChange(fileDataArray, 'files');
      //     }
      //   });
      // };
      
      // const impageUploadTemplate = () => {
      //   return (
      //       <div className='mt-2 items-start'>

      //           <input 
      //             type="file" 
      //             accept="image/*"
      //             onChange={handleImageUpload}
      //             className="hidden" 
      //             multiple
      //             id="image-upload"
      //           />
      //           <label 
      //             htmlFor="image-upload" 
      //             className="px-4 py-2 border rounded-md text-sm font-medium text-gray-700 hover:bg-gray-50 "
      //           >
      //               Add Photos
      //           </label>
      //       </div>
      //   )
      // }
      // -------- FOR FUTURE IMAGE UPLOAD ---------


    return (
        <div className="w-full max-w-2xl mx-auto p-4">    
          <Loader isLoading={isLoading} >
            <div className="text-center mb-8">
              <h2 className="text-2xl sm:text-3xl font-bold text-gray-800 mb-2">
                Contact Information
              </h2>
              <p className="text-gray-600">We'll use this to confirm your selection</p>
            </div>
            <div className="space-y-6">
              <div className="grid grid-cols-1 sm:grid-cols-2 gap-4">
                <Input
                  label="First Name"
                  id="firstName"
                  onChange={onFormDataChange}
                  parentValue={contactData?.firstName || null}
                  placeholder="John"
                  icon={<User className=" w-5 h-5" />}
                />
    
                <Input
                  label="Last Name"
                  id="lastName"
                  onChange={onFormDataChange}
                  parentValue={contactData?.lastName || null}
                  placeholder="Doe"
                  icon={<User className=" w-5 h-5" />}
                />
              </div>
    
              <Input
                label="Email Address"
                id="email"
                type='email'
                onChange={onFormDataChange}
                parentValue={contactData?.email || null}
                placeholder="john.doe@example.com"
                icon={<Mail className=" w-5 h-5" />}
              />
    
              <Input
                label="Phone Number"
                id="phone"
                type='tel'
                onChange={onFormDataChange}
                parentValue={contactData?.phone || null}
                placeholder="(555) 123-4567"
                icon={<Phone className=" w-5 h-5" />}
              />

              {formData.propertyType == 'commercial' && (
                 <Input
                  label="Property Name"
                  id="propertyName"
                  onChange={onFormDataChange}
                  parentValue={contactData?.propertyName || null}
                  placeholder="Your Property Name"
                  icon={<User className=" w-5 h-5" />}
                />
              )}

                <div className="w-full bg-white rounded-2xl shadow-sm border border-stone-200 p-6 mb-4">
                    <textarea
                        placeholder="Special instructions"
                        value={contactData?.special_notes || ''}
                        className="w-full h-24 resize-none leading-relaxed outline-none"
                        onChange={(e) => onFormDataChange(e.target.value, 'special_notes')}
                    />
                </div>


              <div className="flex gap-4">
                <Button
                  label='Back'
                  isDisabled={false}
                  onClick={previousStep}
                />
                <Button
                  label='Continue'
                  isDisabled={isSaveButtonBlocked}
                  onClick={onSubmit}
                  primary
                />
              </div>
            </div>
          </Loader>
        </div>
      );
}